export enum MessageThreadCategory {
  LiveShipment,
  Quote,
  GenericSupport,
  Archived,
  Sendbird,
}
